





















import {Component, Prop, Vue} from 'vue-property-decorator'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

@Component
export default class NetworkToggle extends Vue {
  @Prop({type: Array, required: true}) networks!: TWalletNetwork[]
  @Prop({type: String, required: true}) value!: TWalletNetwork
}
